import React, { useState } from 'react';
import useDms from '../../hooks/useDms';
import { Loading, ErrorBox, Empty } from './shared';
import Pager from '../LiveIntel/Pager';
import { nfmt, money, compactUsd } from '../../lib/formatters';

export default function ReportsTours() {
  const [draft, setDraft] = useState('');
  const [applied, setApplied] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(40);

  const { data, loading, error } = useDms('datasets/touring_tours', {
    q: applied,
    sort: '-Revenue (USD)',
    limit: perPage,
    offset: (page - 1) * perPage,
  });

  const submit = (e) => {
    e.preventDefault();
    setApplied(draft);
    setPage(1);
  };

  const total = data?.total ?? 0;

  return (
    <div className="lyve-intel">
      <div className="hero" style={{ paddingBottom: 0 }}>
        <div className="eyebrow">
          <i />
          REPORTS · TOURS
        </div>
        <h1 className="h-title wide">TOURS</h1>
        <p className="h-sub">
          Every tour box-score post compiled from touringdata.org — headline revenue, tickets, averages, promoter and
          status.
        </p>
      </div>

      <div className="page" style={{ paddingTop: 18 }}>
        <form className="acat-bar" onSubmit={submit}>
          <input
            className="acat-input"
            placeholder="Tour or headliner"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
          <button className="acat-go" type="submit">
            Search
          </button>
        </form>

        {loading && <Loading />}
        {error && <ErrorBox error={error} />}
        {!loading && !error && data?.data?.length === 0 && <Empty label="No tours found." />}
        {!loading && !error && data?.data?.length > 0 && (
          <>
            <div className="fs-meta">
              <span className="num">{nfmt(total)}</span> <span className="faint">tours</span>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Headliner</th>
                  <th>Tour</th>
                  <th>Revenue</th>
                  <th>Tickets</th>
                  <th>Avg price</th>
                  <th>Shows rep.</th>
                  <th>Promoter</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((t) => (
                  <tr key={t['Tour ID']}>
                    <td>{t.Headliner || '—'}</td>
                    <td>{t.Tour}</td>
                    <td>{compactUsd(t['Revenue (USD)'])}</td>
                    <td>{nfmt(t['Tickets sold'])}</td>
                    <td>{money(t['Avg ticket price (USD)'], '$')}</td>
                    <td>{nfmt(t['Shows reported'])}</td>
                    <td>{t.Promoter || '—'}</td>
                    <td>{t.Status || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pager
              total={total}
              page={page}
              perPage={perPage}
              onPage={setPage}
              onPerPage={(v) => {
                setPerPage(v);
                setPage(1);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}
